// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"766":"cf015027","855":"cf015027"}[chunkId] + ".chunk.css";
};